export default "__VITE_ASSET__DCQ6Rqd5__"